import { IconButton, Tooltip, useTheme } from '@mui/material';
import * as Sentry from '@sentry/react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Megaphone } from '@/icons/megaphone';

const SentryReportBugButton = () => {
  const { t } = useTranslation(['common']);
  const {
    palette: { mode },
  } = useTheme();
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const feedback = Sentry.getFeedback();
    const button = buttonRef.current;

    if (!feedback || !button) return;

    feedback.remove();

    const detachFeedback = feedback.attachTo(button, {
      colorScheme: mode,
      triggerLabel: t('sentryFeedback.triggerLabel'),
      triggerAriaLabel: t('sentryFeedback.triggerAriaLabel'),
      cancelButtonLabel: t('sentryFeedback.cancelButtonLabel'),
      submitButtonLabel: t('sentryFeedback.submitButtonLabel'),
      confirmButtonLabel: t('sentryFeedback.confirmButtonLabel'),
      formTitle: t('sentryFeedback.formTitle'),
      emailLabel: t('sentryFeedback.emailLabel'),
      emailPlaceholder: t('sentryFeedback.emailPlaceholder'),
      messageLabel: t('sentryFeedback.messageLabel'),
      messagePlaceholder: t('sentryFeedback.messagePlaceholder'),
      nameLabel: t('sentryFeedback.nameLabel'),
      namePlaceholder: t('sentryFeedback.namePlaceholder'),
      successMessageText: t('sentryFeedback.successMessageText'),
      isRequiredLabel: t('sentryFeedback.isRequiredLabel'),
      addScreenshotButtonLabel: t('sentryFeedback.addScreenshotButtonLabel'),
      removeScreenshotButtonLabel: t('sentryFeedback.removeScreenshotButtonLabel'),
    });

    return () => {
      detachFeedback();
      feedback.remove();
    };
  }, [mode, t]);

  return (
    <Tooltip title={t('reportBug')}>
      <IconButton
        id="sentry-feedback-button"
        ref={buttonRef}
        color="inherit"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
        }}>
        <Megaphone color="inherit" sx={{ width: 20, height: 20 }} />
      </IconButton>
    </Tooltip>
  );
};

export default SentryReportBugButton;
